export default {
  components: {
    homeSkeleton: 'dt.domains.home.components.homeSkeleton',
  },
};
